export const MAIN_COLOR = "#2D75B8";
export const MEDIA_URL = "";
export const MEDIA_URL1 = "";
export const STATUS = {
  pending: 0,
  approved: 1,
  rejected: 2,
};

export const Status = [
  { value: "", name: "None" },
  { value: 0, name: "Pending" },
  { value: 1, name: "Approved" },
  { value: 2, name: "Rejected" },
];

export const ROLE = {
  superadmin: "1",
  admin: "2",
  trainer: "3",
  learner: "4",
};

export const Role = [
  { value: "", name: "None" },
  { value: "Basic", name: "Basic" },
  { value: "Focal", name: "Focal" },
  { value: "Admin", name: "Admin" },
];

export const ACTIVE = {
  active: "Active",
  inactive: "Inactive",
};

export const Active = [
  { value: "", name: "None" },
  { value: "true", name: "Active" },
  { value: "false", name: "Inactive" },
];

export const UserType = [
  { value: "all", name: "All" },
  { value: "principal", name: "Principal" },
  { value: "dependent", name: "Dependent" },
];

export const DOC_TYPE = [
  { value: "ide", name: "Identity Photo" },
  { value: "pas", name: "Passport" },
  { value: "div", name: "Divource Cerificate" },
  { value: "ado", name: "Adopation Cerificate" },
  { value: "not", name: "Note Verbale" },
  { value: "bir", name: "Birth Cerificate" },
  { value: "per", name: "Permit" },
  { value: "app", name: "Appointement Contract" },
  { value: "nai", name: "Declaration de grantie" },
  { value: "mar", name: "Marriage Certificate" },
  { value: "adr", name: "Proof of Address" },
  { value: "unl", name: "UN Laissez Passer" },
  { value: "vis", name: "Visa" },
];

export const APPLICATION_FORMAT = [
  { value: "xml", name: "application/xml" },
  { value: "pdf", name: "application/pdf" },
  { value: "gif", name: "image/gif" },
  { value: "png", name: "image/png" },
  { value: "jpg", name: "image/jpg" },
  { value: "tif", name: "image/tif" },
];

export const TRAINERROLE = [
  { value: 1, name: "Super Admin" },
  { value: 2, name: "Admin" },
  { value: 3, name: "Trainer" },
  { value: 4, name: "Learner" },
  { value: 5, name: "Normal User" },
];

export const APPROVAL_STATUS = ["pending", "approved"];
export const SCORM_COMPLETED_STATUS = ["passed", "completed"];
export const plagiarismMessage =
  "Have patience, this may take sometime to generate report.";

export const DASHBOARDWIDGETSADMIN = [
  { value: 1, label: "Top 5 Courses" },
  { value: 2, label: "Top 5 Categories" },
  { value: 3, label: "Current Statistics" },
  { value: 4, label: "Top Learners" },
  { value: 5, label: "Top Trainers" },
  { value: 6, label: "All Users" },
  { value: 7, label: "New Users" },
  { value: 8, label: "Content" },
];

export const DASHBOARDWIDGETSADMINVALUES = {
  top5Courses: 1,
  top5Categories: 2,
  currentStatistics: 3,
  topLearners: 4,
  topTrainers: 5,
  allUsers: 6,
  newUsers: 7,
  content: 8,
};

export const DASHBOARDWIDGETSTRAINER = [
  { value: 1, label: "Top 5 Courses" },
  { value: 2, label: "Course Wise Performance" },
  { value: 3, label: "Top Learners" },
  { value: 4, label: "Assessments" },
];

export const DASHBOARDWIDGETSTRAINERVALUES = {
  top5Courses: 1,
  courseWisePerformance: 2,
  topLearners: 3,
  assessments: 4,
};

export const DASHBOARDWIDGETSLEARNER = [
  { value: 1, label: "Profile Details" },
  { value: 2, label: "To Do List" },
  { value: 3, label: "Assessment" },
  { value: 4, label: "Learning Path" },
  { value: 5, label: "Courses" },
];

export const DASHBOARDWIDGETSLEARNERVALUES = {
  profileDetails: 1,
  toDoList: 2,
  assessment: 3,
  learningPath: 4,
  courses: 5,
};

export const EXCLUDEUSERASSIGNMENTFILTERS = ["Hiring Manager"];
